<template>
  <TargetedUsers :start-date="startDate" />
</template>
<script setup lang="ts">
import TargetedUsers from "./TargetedUsers.vue";

defineProps({
  startDate: {
    type: String,
    required: true,
  },
});
</script>
